'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002eformat$002e$002dDecimal$002dStyle from "./java.time.format.-Decimal-Style.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_DecimalStyle$() {
  this.Jx = null;
  this.Jy = false;
}
export { $c_Ljava_time_format_DecimalStyle$ as $c_Ljava_time_format_DecimalStyle$ };
$p = $c_Ljava_time_format_DecimalStyle$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_DecimalStyle$;
/** @constructor */
function $h_Ljava_time_format_DecimalStyle$() {
}
export { $h_Ljava_time_format_DecimalStyle$ as $h_Ljava_time_format_DecimalStyle$ };
$h_Ljava_time_format_DecimalStyle$.prototype = $p;
$p.RN = (function() {
  if ((!this.Jy)) {
    this.Jx = new $j_java$002etime$002eformat$002e$002dDecimal$002dStyle.$c_Ljava_time_format_DecimalStyle(48, 43, 45, 46);
    this.Jy = true;
  }
  return this.Jx;
});
var $d_Ljava_time_format_DecimalStyle$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DecimalStyle$, "java.time.format.DecimalStyle$", ({
  lk: 1
}));
export { $d_Ljava_time_format_DecimalStyle$ as $d_Ljava_time_format_DecimalStyle$ };
var $n_Ljava_time_format_DecimalStyle$;
function $m_Ljava_time_format_DecimalStyle$() {
  if ((!$n_Ljava_time_format_DecimalStyle$)) {
    $n_Ljava_time_format_DecimalStyle$ = new $c_Ljava_time_format_DecimalStyle$();
  }
  return $n_Ljava_time_format_DecimalStyle$;
}
export { $m_Ljava_time_format_DecimalStyle$ as $m_Ljava_time_format_DecimalStyle$ };
